import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function TransactionsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");
  const [item, setItem] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [userId, setUserId] = useState(null);
  const [showBalanceSheet, setShowBalanceSheet] = useState(false);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [totalpl, setTotalpl] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [portfolioValue, setPortfolioValue] = useState(0);

  const renderTransactionIcon = (type) => {
    switch(type?.toLowerCase()) {
      case 'debit':
        return <i className="fa fa-arrow-up text-danger"></i>;
      case 'credit':
        return <i className="fa fa-arrow-down text-success"></i>;
      default:
        return <i className="fa fa-arrow-left-right" style={{ color: '#D4AF37' }}></i>;
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const id = localStorage.getItem("userid");
      const userName = localStorage.getItem("name");
      
      if (id) {
        setUserId(id);
        setName(userName || 'User');
        await fetchWalletBalance(id);
        await fetchTransactions(id);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      alert("Failed to load user data");
    } finally {
      setLoading(false);
    }
  };

  const fetchTransactions = async (id) => {
    try {
      const response = await fetch(`https://singlewindowsecurities.com/rest3/mytrans_api/${id}`);
      const data = await response.json();
      setTransactions(data || []);
    } catch (error) {
      console.log("Error fetching transactions:", error);
    }
  };

  const fetchWalletBalance = async (id) => {
    try {
      const response = await fetch(`https://singlewindowsecurities.com/rest3/wallet_api/${id}`);
      const data = await response.json();
      setBalance(data.wallet || 0);
      setPortfolioValue(data.wallet || 0);
      
      const response1 = await fetch(`https://singlewindowsecurities.com/rest3/total_wallet_api/${id}`);
      const data1 = await response1.json();
      setTotalLoss(Math.abs(data1.debits) || 0);
      setTotalProfit(data1.credits || 0);
      setTotalpl(data1.totalpl || 0);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const nameParts = name.split(' ');
    if (nameParts.length >= 2) {
      return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const changeColor = (type) => {
    if (type === 'Credit' || type === 'Trade Credit') {
      return '#00C853';
    } else {
      return '#FF5252';
    }
  };

  const formatIndianCurrency = (num) => {
    if (!num && num !== 0) return '0.00';
    return parseFloat(num).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const getStatusColor = (type) => {
    switch(type?.toLowerCase()) {
      case 'debit':
        return { bg: 'rgba(255, 82, 82, 0.15)', text: '#FF5252' };
      case 'credit':
        return { bg: 'rgba(0, 200, 83, 0.15)', text: '#00C853' };
      default:
        return { bg: 'rgba(212, 175, 55, 0.15)', text: '#D4AF37' };
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#0a0a0a' }}>
        <div className="text-center">
          <div className="spinner-border" style={{ color: '#D4AF37' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3" style={{ color: '#D4AF37' }}>Loading transactions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(10, 10, 10, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div className="container py-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <div style={{
                width: '44px',
                height: '44px',
                background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span className="fw-bold" style={{ color: '#000' }}>{getInitials(name)}</span>
              </div>
              <div className="ms-3">
                <h5 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>Transactions</h5>
                <small style={{ color: '#888' }}>All Your Trading History</small>
              </div>
            </div>
            
            <span style={{
              background: 'rgba(212, 175, 55, 0.15)',
              color: '#D4AF37',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '11px',
              fontWeight: 'bold',
              border: '1px solid rgba(212, 175, 55, 0.3)'
            }}>
              LIVE DATA
            </span>
          </div>

          {/* Portfolio Value Card */}
          <div style={{
            background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.15), rgba(184, 150, 12, 0.05))',
            borderRadius: '20px',
            padding: '20px',
            border: '1px solid rgba(212, 175, 55, 0.2)',
            marginBottom: '16px'
          }}>
            <div className="d-flex justify-content-between align-items-start mb-2">
              <small style={{ color: '#D4AF37', letterSpacing: '1px' }}>PORTFOLIO VALUE</small>
              <button 
                className="btn btn-sm p-0"
                onClick={() => setShowBalanceSheet(true)}
                style={{ color: '#D4AF37' }}
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
            <h2 className="fw-bold" style={{ color: '#D4AF37' }}>₹{formatIndianCurrency(portfolioValue)}</h2>
          </div>

          {/* Stats Summary */}
          <div className="row g-3 mb-3">
            <div className="col-4">
              <div style={{
                background: 'rgba(26, 26, 26, 0.8)',
                borderRadius: '16px',
                padding: '12px',
                textAlign: 'center',
                border: '1px solid rgba(212, 175, 55, 0.1)'
              }}>
                <small style={{ color: '#888', fontSize: '10px' }}>TOTAL P/L</small>
                <div className="fw-bold" style={{ color: totalpl >= 0 ? '#00C853' : '#FF5252' }}>
                  ₹{formatIndianCurrency(totalpl)}
                </div>
              </div>
            </div>
            <div className="col-4">
              <div style={{
                background: 'rgba(26, 26, 26, 0.8)',
                borderRadius: '16px',
                padding: '12px',
                textAlign: 'center',
                border: '1px solid rgba(212, 175, 55, 0.1)'
              }}>
                <small style={{ color: '#888', fontSize: '10px' }}>PROFIT</small>
                <div className="fw-bold" style={{ color: '#00C853' }}>
                  ₹{formatIndianCurrency(totalProfit)}
                </div>
              </div>
            </div>
            <div className="col-4">
              <div style={{
                background: 'rgba(26, 26, 26, 0.8)',
                borderRadius: '16px',
                padding: '12px',
                textAlign: 'center',
                border: '1px solid rgba(212, 175, 55, 0.1)'
              }}>
                <small style={{ color: '#888', fontSize: '10px' }}>LOSS</small>
                <div className="fw-bold" style={{ color: '#FF5252' }}>
                  ₹{formatIndianCurrency(totalLoss)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Transactions List */}
      <div className="container py-3 pb-4">
        {transactions.length === 0 ? (
          <div className="text-center py-5">
            <div style={{
              width: '80px',
              height: '80px',
              background: 'rgba(212, 175, 55, 0.1)',
              borderRadius: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <i className="fa fa-receipt" style={{ color: '#D4AF37', fontSize: '40px' }}></i>
            </div>
            <h5 className="fw-bold" style={{ color: '#fff' }}>No Transactions</h5>
            <p style={{ color: '#888' }}>Your transaction history will appear here</p>
          </div>
        ) : (
          <div className="row g-3">
            {transactions.map((item, index) => (
              <div key={index} className="col-12">
                <div style={{
                  background: 'rgba(20, 20, 20, 0.95)',
                  borderRadius: '20px',
                  border: '1px solid rgba(212, 175, 55, 0.15)',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease'
                }}>
                  <div className="p-3">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex align-items-center">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          background: getStatusColor(item.tr_type).bg,
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '12px'
                        }}>
                          {renderTransactionIcon(item.tr_type)}
                        </div>
                        <div>
                          <h6 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>
                            ₹{formatIndianCurrency(item.tr_amt)} 
                            {item.tr_usd && <span style={{ color: '#888', fontSize: '12px' }}> (${formatIndianCurrency(item.tr_usd)})</span>}
                          </h6>
                          <small style={{ color: '#888' }}>{item.tr_date}</small>
                        </div>
                      </div>
                      
                      <div className="text-end">
                        <span style={{
                          background: getStatusColor(item.tr_type).bg,
                          color: getStatusColor(item.tr_type).text,
                          padding: '4px 10px',
                          borderRadius: '20px',
                          fontSize: '11px',
                          fontWeight: 'bold'
                        }}>
                          {item.buysell_id > 0 ? 'MCX' : ''} 
                          {item.frx_id ? ' FOREX' : ''} 
                          {' ' + (item.tr_type?.charAt(0)?.toUpperCase() + item.tr_type?.slice(1) || '')}
                        </span>
                        <div className="mt-1">
                          <small style={{ color: '#666' }}>Balance: ₹{formatIndianCurrency(item.left_amt)}</small>
                        </div>
                      </div>
                    </div>

                    {/* Transaction Remarks */}
                    {item.tr_desc && (
                      <div className="mt-2 pt-2" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.1)' }}>
                        <small style={{ color: '#888' }}>Remarks:</small>
                        <p className="mb-0 small" style={{ color: '#D4AF37' }}>{item.tr_desc}</p>
                      </div>
                    )}

                    {/* MCX Trade Details */}
                    {item.buysell_id > 0 && (
                      <div style={{
                        background: 'rgba(26, 26, 26, 0.6)',
                        borderRadius: '16px',
                        padding: '12px',
                        marginTop: '12px'
                      }}>
                        <div className="row">
                          <div className="col-8">
                            <div className="row g-2">
                              <div className="col-6">
                                <small style={{ color: '#888' }}>LMT:</small>
                                <div style={{ color: '#D4AF37', fontWeight: 'bold', fontSize: '13px' }}>{item.setlimit}</div>
                              </div>
                              <div className="col-6">
                                <small style={{ color: '#888' }}>TGT:</small>
                                <div style={{ color: '#00C853', fontWeight: 'bold', fontSize: '13px' }}>{item.target}</div>
                              </div>
                              <div className="col-6">
                                <small style={{ color: '#888' }}>STL:</small>
                                <div style={{ color: '#FF5252', fontWeight: 'bold', fontSize: '13px' }}>{item.stoploss}</div>
                              </div>
                              <div className="col-6">
                                <small style={{ color: '#888' }}>EXIT @:</small>
                                <div style={{ color: '#D4AF37', fontWeight: 'bold', fontSize: '13px' }}>{item.last_live}</div>
                              </div>
                              <div className="col-12">
                                <small style={{ color: '#888' }}>TRD ID:</small>
                                <span style={{ color: '#fff', fontSize: '12px' }}> #10000{item.bsid}</span>
                              </div>
                              <div className="col-6">
                                <small style={{ color: '#888' }}>START:</small>
                                <div style={{ color: '#fff', fontSize: '12px' }}>{item.trd_in}</div>
                              </div>
                              <div className="col-6">
                                <small style={{ color: '#888' }}>END:</small>
                                <div style={{ color: '#fff', fontSize: '12px' }}>{item.trd_out}</div>
                              </div>
                            </div>
                          </div>
                          <div className="col-4 text-end">
                            <div className="fw-bold" style={{ color: '#D4AF37', fontSize: '14px' }}>
                              {item.metal}
                            </div>
                            <small style={{ color: '#888' }}>{item.lotsize} Lots</small>
                            <br />
                            <small style={{ color: '#666' }}>{item.bsdate}</small>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* FOREX Trade Details */}
                    {item.frx_id && (
                      <div style={{
                        background: 'rgba(26, 26, 26, 0.6)',
                        borderRadius: '16px',
                        padding: '12px',
                        marginTop: '12px'
                      }}>
                        <div className="row">
                          <div className="col-6">
                            <small style={{ color: '#888' }}>PAIR:</small>
                            <div className="fw-bold" style={{ color: '#D4AF37', fontSize: '13px' }}>{item.cpair}</div>
                          </div>
                          <div className="col-6">
                            <small style={{ color: '#888' }}>Lot:</small>
                            <div className="fw-bold" style={{ color: '#D4AF37', fontSize: '13px' }}>{item.lotsize2} LOT</div>
                          </div>
                          <div className="col-6">
                            <small style={{ color: '#888' }}>Entry Price:</small>
                            <div className="fw-bold" style={{ color: '#00C853', fontSize: '13px' }}>{item.trade_price}</div>
                          </div>
                          <div className="col-6">
                            <small style={{ color: '#888' }}>Exit Price:</small>
                            <div className="fw-bold" style={{ color: '#FF5252', fontSize: '13px' }}>
                              {item.trade_type === 'BUY' ? item.sell_price : item.buy_price}
                            </div>
                          </div>
                          <div className="col-6">
                            <small style={{ color: '#888' }}>Entry Time:</small>
                            <div className="fw-bold" style={{ color: '#fff', fontSize: '12px' }}>{item.trade_start_time}</div>
                          </div>
                          <div className="col-6">
                            <small style={{ color: '#888' }}>Exit Time:</small>
                            <div className="fw-bold" style={{ color: '#fff', fontSize: '12px' }}>{item.trade_exit_time}</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Balance Sheet Modal */}
      {showBalanceSheet && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{
              background: '#1a1a1a',
              borderRadius: '24px',
              border: '1px solid rgba(212, 175, 55, 0.2)'
            }}>
              <div className="modal-header" style={{ borderBottom: '1px solid rgba(212, 175, 55, 0.1)' }}>
                <h5 className="modal-title fw-bold" style={{ color: '#D4AF37' }}>Portfolio Summary</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setShowBalanceSheet(false)}
                ></button>
              </div>
              <div className="modal-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h6 className="mb-1" style={{ color: '#D4AF37' }}>Current Balance</h6>
                    <h2 className="fw-bold" style={{ color: '#D4AF37' }}>₹{formatIndianCurrency(balance)}</h2>
                  </div>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    background: 'rgba(212, 175, 55, 0.1)',
                    borderRadius: '35px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <i className="fa fa-wallet2" style={{ color: '#D4AF37', fontSize: '32px' }}></i>
                  </div>
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-4">
                    <div style={{
                      textAlign: 'center',
                      padding: '12px',
                      background: 'rgba(26, 26, 26, 0.8)',
                      borderRadius: '12px',
                      border: '1px solid rgba(212, 175, 55, 0.1)'
                    }}>
                      <small style={{ color: '#888', fontSize: '10px' }}>Total P/L</small>
                      <div className="fw-bold" style={{ color: totalpl >= 0 ? '#00C853' : '#FF5252' }}>
                        ₹{formatIndianCurrency(totalpl)}
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{
                      textAlign: 'center',
                      padding: '12px',
                      background: 'rgba(26, 26, 26, 0.8)',
                      borderRadius: '12px',
                      border: '1px solid rgba(212, 175, 55, 0.1)'
                    }}>
                      <small style={{ color: '#888', fontSize: '10px' }}>Profit</small>
                      <div className="fw-bold" style={{ color: '#00C853' }}>
                        ₹{formatIndianCurrency(totalProfit)}
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{
                      textAlign: 'center',
                      padding: '12px',
                      background: 'rgba(26, 26, 26, 0.8)',
                      borderRadius: '12px',
                      border: '1px solid rgba(212, 175, 55, 0.1)'
                    }}>
                      <small style={{ color: '#888', fontSize: '10px' }}>Loss</small>
                      <div className="fw-bold" style={{ color: '#FF5252' }}>
                        ₹{formatIndianCurrency(totalLoss)}
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{
                  background: 'rgba(26, 26, 26, 0.8)',
                  borderRadius: '16px',
                  padding: '16px',
                  border: '1px solid rgba(212, 175, 55, 0.1)'
                }}>
                  <div className="d-flex justify-content-between mb-2">
                    <span style={{ color: '#888' }}>Account Holder:</span>
                    <span className="fw-semibold" style={{ color: '#D4AF37' }}>{name}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span style={{ color: '#888' }}>Total Trades:</span>
                    <span className="fw-semibold" style={{ color: '#fff' }}>{transactions.length}</span>
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.1)' }}>
                <button 
                  type="button" 
                  className="btn"
                  onClick={() => setShowBalanceSheet(false)}
                  style={{
                    background: 'rgba(212, 175, 55, 0.1)',
                    border: '1px solid rgba(212, 175, 55, 0.3)',
                    borderRadius: '12px',
                    color: '#D4AF37'
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}